import { Box, Container, useMediaQuery, useTheme } from '@mui/material'
import { useEffect, useRef, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useLocation, useNavigate } from 'react-router-dom'
import CustomButton from '../../../Components/CustomButton/CustomButton'
import { Input } from '../../../Components/Input'
import { makeGetRequest, makePostRequest } from '../../../utils/api'
import urls from '../../../utils/urls'
import CreateOperationForm from './CreateOperationForm'
import ListOperations from './ListOperations'
import ComboBox from '../../../Components/ComboBox'
import EditOperationForm from './EditOperationForm'
import SupprimerOperationForm from './SupprimerOperationForm'
import { useDispatch } from 'react-redux'
import EditIcon from '@mui/icons-material/Edit'
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import CreateMessage from 'containers/MyInbox/CreateMessage'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)
export const MesVehicules = () => {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const [mOpen, setMOpen] = useState(false)
  const navigate = useNavigate()
  const location = useLocation()
  const formRef = useRef()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  const [operations, setOperations] = useState({})
  const [selectedRowsParams, setSelectedRowsParams] = useState({})
  const [selectedRows, setSelectedRows] = useState([])

  const [loading, setLoading] = useState(false)
  const [types, setTypes] = useState([])
  const [general, setGeneral] = useState(true)
  const [selected, setSelected] = useState(false)
  const [selectedSupprimer, setSelectedSupprimer] = useState(false)
  const [carLogoType, setCarLogoType] = useState([])
  const [infoshow, setInfoShow] = useState(true)
  useEffect(() => {
    if (isMobile) {
      setInfoShow(false)
    } else {
      setInfoShow(true)
    }
  }, [isMobile])
  const { handleSubmit, control, setValue, reset } = useForm({
    defaultValues: {
      vehicleType: '',
      Name: '',
      Marque: '',
      Model: '',
      Statut: '',
    },
  })

  useEffect(() => {
    fetchCarPicModel()
  }, [])

  useEffect(() => {
    fetchOperations()
    fetchVehiclesTypes()
  }, [location.search])

  const fetchOperations = async (pagination = '') => {
    setLoading(true)
    let url = `${urls.crudVehiclesOperations}?general=${general}&${location.search.slice(1)}`

    if (pagination !== '') {
      //general=true&
      url += pagination
    }
    const response = await makeGetRequest(url, {}, true)
    if (response.status === 200) {
      setOperations({ ...response.data })
      setLoading(false)
    }
    setLoading(false)
  }

  const filterOperations = (data) => {
    setGeneral(false)
    let s = {
      ...data,
      vehicleType: data.vehicleType ? data.vehicleType.label : '',
    }

    const queryParams = new URLSearchParams(s).toString()

    navigate(`?${queryParams}`)
  }

  const deleteBulkOperations = async () => {
    if (selectedRows.length === 0) {
      // LAP-733 (GE022)
      alert(t('vehicles.alertSelectOne'))
    } else {
      const filteredOperations = operations.results.filter((v) => selectedRows.indexOf(v.id) === -1)
      setOperations({
        ...operations,
        results: filteredOperations,
        count: operations.count - selectedRows.length,
      })
      const response = await makePostRequest(
        urls.deleteBulkVehiclesOperations,
        { selected: selectedRows },
        {},
        true,
      )
      if (response.status === 200) {
      }
    }
  }
  const fetchCarPicModel = async () => {
    const url = urls.fetchCarPicModel
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      // const filterTypes = []
      // data.forEach((v) => {
      //   filterTypes.push({ label: `${v.Name}`, id: v.id })
      // })
      // setCarType([...filterTypes])
      setCarLogoType(data)
    }
  }
  const fetchVehiclesTypes = async () => {
    const url = urls.fetchVehiclesTypes + '?limit=100000'
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const filterTypes = []
      data.forEach((v) => {
        filterTypes.push({ label: `${v.vehicletype}`, id: v.id })
      })
      setTypes([...filterTypes])
    }
  }

  const clearFilter = () => {
    setGeneral(true)
    navigate(``)

    let v = document.getElementsByClassName('MuiAutocomplete-clearIndicator')
    if (v.length > 0) v[0].click()
    reset()
  }

  return (
    <>
      {mOpen && (
        <CreateMessage
          setMOpen={setMOpen}
          /* LAP-733 (GE022) */
          title={t('vehicles.shareTitle')}
          settingId={4}
          vehicule={operations.results.filter((v) => v.id === selectedRows[0])[0]}
        />
      )}
      <Box bgcolor={'#001b42'} p={1}>
        <Container maxWidth="xl" sx={{ display: infoshow ? 'block' : 'none' }}>
          <form onSubmit={handleSubmit(filterOperations)}>
            <Box display={'flex'} flexWrap="wrap">
              <ComboBox
                handleAutoComplete={(e, j) => {
                  setValue('vehicleType', j)
                }}
                /* LAP-733 (GE022) */
                label={t('vehicles.labelType')}
                data={types}
                name="vehicleType"
              />
              <Input
                classAttr="_input"
                control={control}
                name="Name"
                inputProps={{
                  variant: 'filled',
                  type: 'text',
                }}
                rules={{ required: false }}
                /* LAP-733 (GE022) */
                label={t('vehicles.labelName')}
              />
              <Input
                classAttr="_input"
                control={control}
                name="Marque"
                inputProps={{
                  variant: 'filled',
                  type: 'text',
                }}
                rules={{ required: false }}
                /* LAP-733 (GE022) */
                label={t('vehicles.labelBrand')}
              />
              <Input
                classAttr="_input"
                control={control}
                name="Model"
                inputProps={{
                  variant: 'filled',
                  type: 'text',
                }}
                rules={{ required: false }}
                /* LAP-733 (GE022) */
                label={t('vehicles.labelModel')}
              />
              <Input
                classAttr="_input"
                control={control}
                name="Statut"
                inputProps={{
                  variant: 'filled',
                  type: 'text',
                }}
                rules={{ required: false }}
                /* LAP-733 (GE022) */
                label={t('vehicles.labelStatus')}
              />

              <CustomButton
                type="submit"
                sx={{
                  color: 'white',
                  height: '20px',
                  marginTop: 'auto',
                  marginBlock: 'auto',
                  marginLeft: '15px',
                  '&:hover': { color: 'black', backgroundColor: 'white' },
                }}
              >
                {/* LAP-733 (GE022) */}
                {t('vehicles.btnFilter')}
              </CustomButton>
              <CustomButton
                onClick={clearFilter}
                sx={{
                  color: 'white',
                  height: '20px',
                  marginTop: 'auto',
                  marginBlock: 'auto',
                  marginLeft: '15px',
                  '&:hover': { color: 'black', backgroundColor: 'white' },
                }}
              >
                {/* LAP-733 (GE022) */}
                {t('vehicles.btnClearFilter')}
              </CustomButton>
            </Box>
          </form>
        </Container>
        <Box display={'flex'} justifyContent={'center'} mt={1}>
          {isMobile && (
            <>
              {infoshow ? (
                <KeyboardArrowUpIcon
                  sx={{
                    color: 'white',
                    bgcolor: 'gray',
                    borderRadius: 5,
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    setInfoShow(!infoshow)
                  }}
                />
              ) : (
                <KeyboardArrowDownIcon
                  sx={{
                    color: 'white',
                    bgcolor: 'gray',
                    borderRadius: 5,
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    setInfoShow(!infoshow)
                  }}
                />
              )}
            </>
          )}
        </Box>
      </Box>

      <Container maxWidth="xl">
        {selected ? (
          <EditOperationForm
            setOperations={setOperations}
            setSelected={setSelected}
            params={selectedRowsParams}
            operations={operations}
            vehiculesTypes={types}
            carLogoType={carLogoType}
          />
        ) : (
          ''
        )}
        {selectedSupprimer ? (
          <SupprimerOperationForm
            setOperations={setOperations}
            setSelected={setSelected}
            params={selectedRowsParams}
            operations={operations}
            vehiculesTypes={types}
            setSelectedSupprimer={setSelectedSupprimer}
          />
        ) : (
          ''
        )}
        <Box justifyContent="flex-end" padding={2} display="flex">
          {isMobile ? (
            <Box color={'white'} display={'flex'} gap={2}>
              <CreateOperationForm
                setOperations={setOperations}
                vehiculesTypes={types}
                carLogoType={carLogoType}
                fetchCarPicModel={fetchCarPicModel}
              />
              <RemoveCircleIcon onClick={deleteBulkOperations} />
              <EditIcon
                onClick={() => {
                  if (selectedRows.length === 1) {
                    // formRef.current.handleClickOpen(true)
                    setSelectedRowsParams({
                      ...operations.results.filter((v) => v.id === selectedRows[0]),
                    })
                    setSelected(true)
                  } else {
                    setSelected(false)
                    /* LAP-733 (GE022) */ alert(t('realEstate.alertSelectDocEdit'))
                  }
                }}
              />
            </Box>
          ) : (
            <Box display={'flex'}>
              <CustomButton
                onClick={() => {
                  if (selectedRows.length === 1) {
                    setMOpen(true)
                  } else {
                    /* LAP-733 (GE022) */
                    alert(t('realEstate.alertSelectDocShare'))
                  }
                }}
              >
                {/* LAP-733 (GE022) */}
                {t('vehicles.btnShare')}
              </CustomButton>
              <CreateOperationForm
                setOperations={setOperations}
                vehiculesTypes={types}
                carLogoType={carLogoType}
                fetchCarPicModel={fetchCarPicModel}
              />
              <CustomButton
                onClick={() => {
                  if (selectedRows.length === 1) {
                    // formRef.current.handleClickOpen(true)
                    setSelectedRowsParams({
                      ...operations.results.filter((v) => v.id === selectedRows[0]),
                    })
                    setSelected(true)
                  } else {
                    setSelected(false)
                    /* LAP-733 (GE022) */ alert(t('realEstate.alertSelectDocEdit'))
                  }
                }}
              >
                {/* LAP-733 (GE022) */}
                {t('vehicles.btnEdit')}
              </CustomButton>

              {/* LAP-733 (GE022) */}
              <CustomButton onClick={deleteBulkOperations}>{t('vehicles.btnDelete')}</CustomButton>
            </Box>
          )}
        </Box>

        <ListOperations
          fetchOperations={fetchOperations}
          setSelectedRows={setSelectedRows}
          operations={operations}
        />
      </Container>
    </>
  )
}
